import { Link, useLocation } from "react-router-dom";
import { useEffect } from "react";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-muted">
      <div className="text-center">
        <h1 className="mb-4 text-4xl font-bold">404</h1>
        <p className="mb-4 text-xl text-muted-foreground">Fant ikke siden</p>
        {/* Router-Link, ikke <a href>: full innlasting kastet app-state (VIB-2536). */}
        <Link to="/" className="text-primary underline hover:text-primary/90">
          Gå til forsiden
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
